module.exports = __webpack_public_path__ + "img/background-todos.252b7227.png";